import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, forMember, mapFrom, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withMetadata,
} from '@pf/shared-utility';
import {
    PutAwayCreate,
    PutAwayDto,
    PutAwayRead,
    PutAwaySearchParams,
} from '../../entities/put-away.dto';

const symbols = entitySymbols(PFWmsEntities.PutAway);

withDefaultEntityMetadata<PutAwayDto>(symbols.dto, {
    putAwayBy: String,
    putAwayListId: String,
    inventoryBundle: Object,
    container: Object,
    putAwayToSlot: Object,
});

withDefaultEntityMetadata<PutAwayRead>(symbols.entity, {
    putAwayBy: String,
    inventoryBundle: Object,
    container: Object,
    putAwayToSlot: Object,
});

withMetadata<PutAwayCreate>(symbols.createBody, {
    putAwayBy: String,
    inventoryBundleId: String,
    containerId: String,
    putAwayToSlotId: String,
});

withDefaultSearchParamsMetadata<PutAwaySearchParams>(symbols.searchParams, {});

export const PutAwayMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<PutAwayRead, PutAwayDto>(mapper, symbols.entity, symbols.dto);
        createMap<PutAwayDto, PutAwayRead>(mapper, symbols.dto, symbols.entity);
        createMap<PutAwayDto, PutAwayCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            forMember(
                d => d.inventoryBundleId,
                mapFrom(s => s.inventoryBundle?.id ?? null)
            ),
            forMember(
                d => d.containerId,
                mapFrom(s => s.container?.id ?? null)
            ),
            forMember(
                d => d.putAwayToSlotId,
                mapFrom(s => s.putAwayToSlot?.id ?? '')
            )
        );
        createMap<IQueryParams<PutAwayDto>, PutAwaySearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            ...withDefaultSearchParamsMappingConfiguration<PutAwaySearchParams>()
        );
    },
};
